export const XERO_AUTH_STEPS = [
  { id: 'connect', label: 'Connect' },
  { id: 'accounts', label: 'Select accounts' },
  { id: 'done', label: 'Done' },
];

export const XERO_AUTH_STEP_INDEX = {
  connect: 0,
  accounts: 1,
  allComplete: XERO_AUTH_STEPS.length,
};
